import cx from 'classnames'
import { FC, useCallback } from 'react'
import {
  focusMainGrid,
  isOpenFinRuntime
} from '../../containers/OpenFin/helpers'
import { abbreviateVolume } from '../../helpers/formatting'
import { setSecuritySearch } from '../../store/benchmarkData/actions'
import { BenchmarkInfo, BenchmarkList } from '../../store/benchmarkData/types'
import { setQueryFilter } from '../../store/securities/actions'
import { getQueryFilter } from '../../store/securities/selectors'
import { useAppDispatch, useAppSelector } from '../../store/types'

import styles from './benchmarkData.module.scss'

interface Props {
  benchmarkData: BenchmarkInfo
}

const BenchmarkData: FC<Props> = ({ benchmarkData }) => {
  const isOpenFin = isOpenFinRuntime()
  const dispatch = useAppDispatch()
  const queryFilter = useAppSelector(getQueryFilter)(0)

  const searchSecurity = useCallback(
    (value: string) => {
      dispatch(setSecuritySearch(0, value))
      dispatch(setQueryFilter(0, value || undefined))
      if (isOpenFin) void focusMainGrid()
    },
    [dispatch, isOpenFin]
  )

  const getButtonClass = useCallback(
    (isin: string) => {
      return cx(styles.benchmarkButton, {
        [styles.selectedButton]: queryFilter === isin
      })
    },
    [queryFilter]
  )

  const containerClass = cx(styles.benchmarkContainer, {
    [styles.isFin]: isOpenFin
  })

  return (
    <>
      {isOpenFin && <title>Benchmarks</title>}
      <div className={containerClass}>
        <div className={styles.benchmarkTitle}>
          Live on <br /> BondsPro:
        </div>
        <div className={styles.benchmarkData}>
          {benchmarkData.totalOrders.toLocaleString()}{' '}
          <div className={styles.benchmarkLabel}>TOTAL ORDERS</div>
        </div>
        <div className={styles.benchmarkData}>
          {abbreviateVolume(benchmarkData.notional * 1000)}{' '}
          <div className={styles.benchmarkLabel}>NOTIONAL</div>
        </div>
        <div className={styles.benchmarkTitle}>
          Treasury <br /> Benchmarks:
          <br />
          <span>(Click to trade)</span>
        </div>
        {benchmarkData.benchmarkData.map((item: BenchmarkList) => (
          <button
            key={item.id}
            className={getButtonClass(item.isin)}
            onClick={() =>
              searchSecurity(queryFilter === item.isin ? '' : item.isin)
            }
            data-testid={`benchmark-button-${item.benchmarkName.toLowerCase()}`}
            title="Click to trade"
          >
            <p className={styles.benchmarkYearLabel}>{item.benchmarkName}</p>
            <p>
              {item.bestBid}/{item.bestOffer}
            </p>
            <p>{item.yield ? item.yield.toFixed(2) : 'N/A'}</p>
          </button>
        ))}
      </div>
    </>
  )
}

export default BenchmarkData
